export const kingIdle = new Image();
kingIdle.src = "./assets/characterSprites/king/kingIdle.png";
kingIdle.width = 1280/8
kingIdle.height = 111
kingIdle.yOffset = 38
kingIdle.xOffset = 150
kingIdle.cycleLoop = [0, 1, 2, 3, 4, 5, 6, 7];